import { Box, Button, Typography } from '@mui/material'
import { Event as EventIcon } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatLessonClock } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface LessonPayload {
  id: number
  planned_start_at: string | null
  teacher?: { display_name?: string } | null
}

export function NextLessonWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const lesson = (payload.lesson ?? null) as LessonPayload | null

  if (!lesson) {
    return (
      <EmptyHint
        hint={typeof payload.hint === 'string' ? payload.hint : undefined}
        fallbackKey="dashboard.widgets.next_lesson.empty"
      />
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <EventIcon color="primary" fontSize="large" />
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h6" fontWeight={700}>
          {formatLessonClock(lesson.planned_start_at, { withDate: true })}
        </Typography>
        {lesson.teacher?.display_name && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {lesson.teacher.display_name}
          </Typography>
        )}
      </Box>
      <Button size="small" component={Link} to={ROUTES.LESSON_DETAILS(lesson.id)}>
        {t('dashboard.widgets.next_lesson.open')}
      </Button>
    </Box>
  )
}
